export const propostaSharedKeys = {
  proposta: ['proposta'] as const,
  listaSimulacoesLancadas: (simulacoesIds: string[]) =>
    [...propostaSharedKeys.proposta, 'simulacoes', ...simulacoesIds] as const,
}
